var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.4,84.44h-31.28c-.55,0-1-.45-1-1s.45-1,1-1h31.28c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.98,84.44h-23.86c-.55,0-1-.45-1-1s.45-1,1-1h22.86V16.73h-32.21v13.67c0,.55-.45,1-1,1s-1-.45-1-1v-14.67c0-.55.45-1,1-1h34.21c.55,0,1,.45,1,1v67.71c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.46,26.41h-11.38c-.55,0-1-.45-1-1s.45-1,1-1h11.38c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.46,33.67h-11.38c-.55,0-1-.45-1-1s.45-1,1-1h11.38c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.46,40.94h-11.38c-.55,0-1-.45-1-1s.45-1,1-1h11.38c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.46,48.2h-11.38c-.55,0-1-.45-1-1s.45-1,1-1h11.38c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.46,55.46h-11.38c-.55,0-1-.45-1-1s.45-1,1-1h11.38c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.46,62.73h-11.38c-.55,0-1-.45-1-1s.45-1,1-1h11.38c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.46,69.99h-11.38c-.55,0-1-.45-1-1s.45-1,1-1h11.38c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.26,69.89h-31.28c-.55,0-1-.45-1-1s.45-1,1-1h31.28c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.84,69.89h-23.86c-.55,0-1-.45-1-1s.45-1,1-1h22.86V2.18s-32.21,0-32.21,0v13.55c0,.55-.45,1-1,1s-1-.45-1-1V1.18c0-.55.45-1,1-1h34.21c.27,0,.52.11.71.29s.29.44.29.71v67.71c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.32,11.85h-11.65c-.55,0-1-.45-1-1s.45-1,1-1h11.65c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.32,19.12h-11.65c-.55,0-1-.45-1-1s.45-1,1-1h11.65c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.32,26.38h-11.65c-.55,0-1-.45-1-1s.45-1,1-1h11.65c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.32,33.64h-11.65c-.55,0-1-.45-1-1s.45-1,1-1h11.65c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.32,40.91h-11.65c-.55,0-1-.45-1-1s.45-1,1-1h11.65c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.32,48.17h-11.65c-.55,0-1-.45-1-1s.45-1,1-1h11.65c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.32,55.43h-11.65c-.55,0-1-.45-1-1s.45-1,1-1h11.65c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.54,99.03H1.5c-.55,0-1-.45-1-1s.45-1,1-1h49.04c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.12,99.03H8.92c-.27,0-.52-.11-.71-.29s-.29-.44-.29-.71V30.32c0-.55.45-1,1-1h34.21c.27,0,.52.11.71.29s.29.44.29.71v67.71c0,.55-.45,1-1,1ZM9.92,97.03h32.21V31.32s-32.21,0-32.21,0v65.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.67,41H15.53c-.55,0-1-.45-1-1s.45-1,1-1h22.14c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.67,48.26H15.53c-.55,0-1-.45-1-1s.45-1,1-1h22.14c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.67,55.53H15.53c-.55,0-1-.45-1-1s.45-1,1-1h22.14c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.67,62.79H15.53c-.55,0-1-.45-1-1s.45-1,1-1h22.14c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.67,70.05H15.53c-.55,0-1-.45-1-1s.45-1,1-1h22.14c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.67,77.32H15.53c-.55,0-1-.45-1-1s.45-1,1-1h22.14c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.67,84.58H15.53c-.55,0-1-.45-1-1s.45-1,1-1h22.14c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.1ea5b92ad47136c76d59695a0c07afa8.svg";
export { ForwardRef as ReactComponent };